"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitDetail = void 0;
const models_1 = require("../models");
const shipping_kit_line_detail_response_1 = require("./shipping-kit-line-detail.response");
class ShippingKitDetail extends models_1.ShippingKit {
}
exports.ShippingKitDetail = ShippingKitDetail;
//# sourceMappingURL=shipping-kit-detail.response.js.map